import moment from 'moment';
import { DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { CreateEditPrepWorksheetEnum } from 'Common/FieldEnum';
import {
  SortEnum,
  StatusEnum,
} from 'Common/Constants/Enumeration/KitchenPrepWorksheet';

export const BASE_URL = '/preparedkitchenitems';

export const viewStatusOptions = [
  { value: StatusEnum.All, label: 'All' },
  { value: StatusEnum.Open, label: 'Open' },
  { value: StatusEnum.Closed, label: 'Closed' },
];
export const printOptions = [
  { value: SortEnum.ItemCode, label: 'Item Code' },
  { value: SortEnum.ItemDescription, label: 'Item Description' },
];

export const prepareSaveKitchenPrepPayload = (values, kitchenType, id) => {
  return {
    TransactionId: id,
    DeliveryDate: moment(values[CreateEditPrepWorksheetEnum.DeliveryDT]).format(
      DATE_FORMAT_FOR_SERVER
    ),
    KitchenId: values[CreateEditPrepWorksheetEnum.Kitchen],
    Comments: values[CreateEditPrepWorksheetEnum.Comments],
    KitchenPrepSaveType: kitchenType,
    KitchenItemList:
      values[CreateEditPrepWorksheetEnum.KitchenPrepWorksheetInfo],
  };
};



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/helper/createEditPrepWorksheet.js